<template>
    <div>
        <HeaderBar/>
        <div class="px-1 bg-white">
            <div class="dataUploadTitle mt-5">Cargar datos Andrología</div>
            <div>
                <validation-observer  ref="GanForm">
                    <b-form  @submit.prevent="">
                        <b-form-group class="datePicker" label="Fecha">
                            <validation-provider #default="{ errors }" name="Fecha" rules="required">
                                <b-form-datepicker v-model="andrology.date" class="form-control" 
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                :min="minCfgDate" :max="maxCfgDate"
                                locale="es-ES"/>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                            
                        </b-form-group>
                        <b-form-group label="Veterinario" label-for="veterinarian" class="veterian">
                            <validation-provider #default="{ errors }" name="Veterinario" rules="required">
                                <b-form-input id="veterinarian" v-model="andrology.veterinarian"
                                    :state="errors.length > 0 ? false : null" name="veterinarian" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label="Seleccionar toro" label-for="selFemale"  class="selFemale" >
                            <validation-provider #default="{ errors }" name="Toro" rules="required">
                                <b-form-select  id="selFemale" placeholder="Buscar y seleccionar Animal" v-model="andrology.animal_id" :options="males" :values="males.value" label="text"  />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label="Condición" label-for="condition"  class="condition" >
                            <validation-provider #default="{ errors }" name="Condición" rules="required">
                                <b-form-select  id="condition" v-model="andrology.condition_id" :options="conditionOptions" :values="conditionOptions.value"  label="text"  />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group class="detail" label="Detalle" label-for="detail">
                            <validation-provider #default="{ errors }" name="Detalle" rules="required">
                                <b-form-textarea rows="3" id="detail" v-model="andrology.details"></b-form-textarea> 
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-form>
                </validation-observer>
                <div class="d-flex justify-content-center mt-5">
                    <!-- <div>Subir archivo o foto:</div>
                    <div class="d-flex align-items-center ml-3 justify-content-center">
                        <b-img src="@/assets/images/ganImage/uploadImage.png"/>
                    </div> -->
                    <b-button
                        type="submit"  v-on:click="insertAndrology"
                        class="bg-primary dataButton mt-1 d-flex align-items-center justify-content-center ml-3"   
                    >
                        <div class="ml-5"> Incluir Evento </div> 
                        <div class="pl-3" style="color:#D7B92C"> 
                            <feather-icon icon="PlusIcon"  size="18" />
                        </div>
                    </b-button>
                </div>
            </div>
            <ControlMenu />
        </div>
    </div>
</template>



<script>
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol,BFormTextarea ,BFormDatepicker,BFormSelect ,BFormGroup, BFormInput, BForm, BImg, BButton } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'

export default {
    components: {
        ControlMenu,
        HeaderBar,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BFormDatepicker,
        BForm,
        required,
        vSelect,
        BImg,
        BFormTextarea,
        BButton,
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 119)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            date: null,
            dateDefault: null,
            timePicker: null,
            datetime: null,
            multiDate: null,
            rangeDate: null,
            humanDate: null,
            disableDate: null,
            inlineDate: null,
            veterinarian: '',
            males:[],
            text:'',
            condition:null,
            animal_picker:0,
            condition_picker:0,
            conditionOptions:[],
            andrology:{
                farm_id: localStorage.getItem('currentFarm'),
                animal_id:null,
                male_id:null,
                type:7,
                condition_id:null,
                date:now,
                veterinarian:null,
                details:"",
                status:1
            }
        }
    },

    methods: {

        async fetchCondition(config) {
            
            fetch(this.$apiUrl+"list/conditions", config)
            .then(response => response.json())
            .then(result => {
                this.conditionOptions = result.conditions.map(item => {return {text:item.name, value:item.id}})
            })
        },

        async fetchAnimals(config){
            let self = this;
            let farmId= localStorage.getItem('currentFarm');
            fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&sex=0&state=1", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animals);
                result.animals.forEach(function(row){
                    if(row.age>=15){
                        self.males.push({value:row.id,text:row.number+ ' '+row.name})
                    }
                })
                //this.males = result.animals.map(item => {return {text:item.number+'-'+item.name,value:item.id}});
                console.log(this.animals);
            })
        },

        insertAndrology(){
            this.$refs.GanForm.validate().then(success => {
                if(success){
                    let self=this;
                    //this.andrology.condition_id=this.condition_picker.value;
                    //this.andrology.animal_id=this.animal_picker.value;
                    this.andrology.male_id=this.andrology.animal_id;
                    console.log(this.andrology);
                    const token = localStorage.getItem("accessToken");
                    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                    this.$http.post("add/reproductive_records", this.andrology, config).then(() => {
                        this.andrology={
                            animal_id:0,
                            male_id:59,
                            type:7,
                            condition_id:0,
                            date:null,
                            veterinarian:"",
                            details:"",
                            status:1
                        }
                    
                        this.$swal({
                            title: 'Registro reproductivo',
                            text: 'Se insertó registro de andrologia de manera satisfactoria',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            history.back();
                        });
                    }).catch(error => {
                        console.log(error)
                    });
                }
            })
            
        },

    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchCondition(config);
        this.fetchAnimals(config);
    }
}
</script>
    

<style lang="scss">
.dataUploadTitle {
    font-weight: 600;
    font-size: 24px;
}


/* @import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss'; */
</style>